export default function scrollTo({ element, to, duration = 300, callback }) {
  const start = element.scrollLeft;
  const change = to - start;
  let startTime;

  if (!change) {
    if (callback) {
      callback();
    }
    return;
  }

  const animateScroll = (currentTime) => {
    if (!startTime) startTime = currentTime;
    const progress = currentTime - startTime;

    const easeInOutQuad = (initialValue, changeInValue) => {
      let time = progress;
      time /= duration / 2;
      if (time < 1) { return ((changeInValue / 2) * time * time) + initialValue; }
      time--;
      return initialValue - ((changeInValue / 2) * ((time * (time - 2)) - 1));
    };

    element.scrollLeft = easeInOutQuad(start, change); // eslint-disable-line no-param-reassign

    if (progress < duration) {
      window.requestAnimationFrame(animateScroll);
    } else {
      element.scrollLeft = to; // eslint-disable-line no-param-reassign
      if (callback) {
        callback();
      }
    }
  };

  window.requestAnimationFrame(animateScroll);
}
